module.exports = __webpack_public_path__ + "images/emoji/clock11.a3a8dc02858a80d8a267.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock11.png
// module id = 4Wyf
// module chunks = 14